import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ICON } from '@shared/constants/icons.constant';
import { ROOT_URLS } from '../../../../core/constants/urls.constants';

@Component({
  selector: 'backoffice-not-found',
  imports: [MatIconModule, TranslateModule, RouterLink],
  templateUrl: './not-found.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './not-found.page.css',
})
export class NotFoundPage {
  readonly dashboardUrl: string = ROOT_URLS.dashboard;

  readonly ICON: typeof ICON = ICON;
}
